import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import classNames from 'classnames';
import dayjs from 'dayjs';
import { useMemo } from 'react';
import { useStore } from 'zustand';

import { INVENTORY_DATE_SIZE, inventoryStore } from '../../../InventoryStore';

import styles from './TimePeriods.module.scss';
import { useTimePeriodNavigation } from './hooks/useTimePeriodNavigation';

export const TimePeriods = () => {
  const timePeriod = useStore(inventoryStore, (state) => state.timePeriod);

  const duplicationDateSelection = useStore(
    inventoryStore,
    (state) => state.duplicationDateSelection
  );

  const tab = useStore(inventoryStore, (state) => state.tab);

  const { handlePrevious, handleNext, handleToday } = useTimePeriodNavigation(
    tab.name
  );

  const selectedDatesSet = useMemo(
    () =>
      new Set(
        duplicationDateSelection.map((d) => dayjs(d).format('YYYY-MM-DD'))
      ),
    [duplicationDateSelection]
  );

  const dates = useMemo(
    () =>
      Array.from({ length: INVENTORY_DATE_SIZE }, (_, index) => {
        const date = dayjs(timePeriod.startDate).add(index, 'day');

        return {
          date,
          dateKey: date.format('YYYY-MM-DD'),
          isSunday: date.day() === 0,
          dayLabel: date.format('ddd'),
          dateLabel: date.format('DD/MM'),
          isToday: date.isSame(dayjs(), 'day'),
        };
      }),
    [timePeriod.startDate]
  );

  return (
    <div className={styles.timeperiodContainer}>
      <div className={styles.timeperiodHeader}>
        <div className={styles.timeperiodCellText}>
          <div className={styles.timeperiodControls}>
            <Button
              className={styles.timeperiodButton}
              icon={<LeftOutlined />}
              onClick={() => handlePrevious(dayjs(timePeriod.startDate))}
            />
            <Button
              className={styles.timeperiodTodayButton}
              onClick={handleToday}
            >
              Today
            </Button>
            <Button
              className={styles.timeperiodButton}
              icon={<RightOutlined />}
              onClick={() => handleNext(dayjs(timePeriod.startDate))}
            />
          </div>
        </div>

        {dates.map((date) => {
          const isSelected = selectedDatesSet.has(date.dateKey);

          return (
            <div
              key={date.dateKey}
              className={classNames([
                styles.timeperiodCellAttribute,
                {
                  [styles['isSunday']]: date.isSunday,
                  [styles['isSelected']]: isSelected,
                  [styles['isToday']]: date.isToday,
                },
              ])}
            >
              <span className={styles.timeperiodWeekDay}>{date.dayLabel}</span>
              <span className={styles.timeperiodLabel}>{date.dateLabel}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
